// list for 'small title' form style
const smallTitleList = [
  'WELCOMEGPP',
  'WELCOMEGCH',
  'WELCOMEGPJ',
  'WELCOMEGJP',
  'WELCOMEOUTBOUND',
  'WELCOMEGJM',
  'WELCOMEGPF',
  'WELCOMEGJS',
  'WELCOMEGXOJET',
  'WELCOMEGFLYXO',
  'WELCOMEGBDB',
  'WELCOMEGNBDB',
  'WELCOMEGNBCDB',
  'WELCOMEGBUK',
  'WELCOMEGNBUK',
  'WELCOMEGNBCUK',
  'WELCOMEFBDB',
  'WELCOMEGNBMENA',
  'WELCOMEFBUK',
  'WELCOMEFBUSA',
  'WELCOMEBBXO',
  'WELCOMEBNBGXO',
  'WELCOMEBNBCXO',
  'WELCOMEGFLGEO',
  'WELCOMEFBFLGEO',
  'WELCOMEFBNYGEO',
  'WELCOMEFBCAGEO',
  'WELCOMEGNYGEO',
  'WELCOMEGCAGEO',
  'WELCOMEFBUKGEO',
  'WELCOMEGUKGEO',
  'WELCOMEGCOMP',
  'WELCOMEGNJ',
  'WELCOMEGWU',
  'WELCOMEGJSX',
  'WELCOMEGDPJ',
  'WELCOMEGXOJET',
  'WELCOMEGJS',
  'WELCOMEBBXOJET',
  'WELCOMEBBJS',
  'WELCOMEGVJ',
  'WELCOMEBBVJ',
  'WELCOMEFBVJ',
  'FLYXO',
  'WELCOMEBCOMP',
  'WELCOMEBNJ',
  'WELCOMEBWU',
  'WELCOMEBJSX',
  'WELCOMEBDPJ',
  'WELCOMEBPF',
  'WELCOMEGPF',
  'WELCOMETT',
  'WELCOMEAK',
  'WELCOMEIMPACT',
]

// list for 'transparent' form style
const transparentFormList = ['WELCOMEGNBGXOB', 'WELCOMEGBXOB']
const arabicList = ['WELCOMEFBDB', 'WELCOMEGNBMENA']

const getHeaderText = (code) => {
  if (arabicList.includes(code)) {
    return 'اشترك للحصول على رصيد ترويجي بقيمة 1000 دولار'
  }
  return 'Sign up for $1,000 in promo credit'
}

const customStylesMap = new Map()

smallTitleList.forEach((code) =>
  customStylesMap.set(code, {
    formClassName: 'small-title',
    signup: { header: getHeaderText(code) },
  })
)
transparentFormList.forEach((code) =>
  customStylesMap.set(code, { formClassName: 'little-transparent' })
)
customStylesMap.set('rise', { login: { header: 'Please Log In with your JetSmarter account' } })

export const getCustomFormStyle = (code) => customStylesMap.get(code)
